<template>
<div class="setting h-full">
  <BaseContainer>
    <template slot="content">
      <div class="admin-list-wrap">
        <div class="banner basic-banner" v-if="companyVersionData.type !== AuthConfig.TeamFree" v-custom="'out_D35_1'" ref="banner">
          <div class="font-semibold mb-5">
            <span class="text-medium-x">当前版本：{{ companyVersionData.type === AuthConfig.TeamBase ? '尊享版' : '旗舰版' }}</span>
            <el-button type="primary" size="mini" class="mini-btn" @click="toVersionPrice">升级版本</el-button>
          </div>
          <div>
            <span class="text-medium">到期时间：{{ companyVersionData.expirationTime }}</span>
            <el-button type="text" class="ml-3 -mt-0.5" @click="toVersionPrice">续费</el-button>
          </div>
        </div>
        <div class="banner common-banner" v-custom="'out_D35_1'" v-else ref="banner">
          <div class="mb-3">升级版本，可享受 50 多种会员权益</div>
          <el-button type="primary" size="mini" style="width: 128px;" @click="toVersionPrice">立即升级</el-button>
        </div>

        <div class="form-box">
          <el-form class="form" :model="form" label-width="95px" :rules="rules" ref="ruleForm">
            <el-form-item label="企业名称：" prop="name">
              <el-input v-model="form.name" placeholder="请输入公司名称" maxlength="120" style="width: 340px;"></el-input>
            </el-form-item>
            <el-form-item label="企业地址：" prop="area">
              <el-cascader
                style="width: 340px;"
                v-model="areaCity"
                :options="city"
                placeholder="请选择公司地址"
                @change="chooseCity"/>
            </el-form-item>
            <el-form-item label="详细地址：" prop="principal">
              <el-input v-model="form.address" placeholder="请输入详细地址(4-120个字符)" maxlength="120" style="width: 340px;"></el-input>
            </el-form-item>
            <el-form-item label="负责人：" prop="principal">
              <el-input v-model="form.principal" placeholder="请输入负责人" style="width: 128px;"></el-input>
            </el-form-item>
            <el-form-item label="联系电话：" prop="telephone">
              <el-input v-model="form.telephone" placeholder="请输入联系电话" style="width: 128px;"></el-input>
            </el-form-item>
            <el-form-item label="公司邮箱：" prop="email">
              <el-input v-model="form.email" placeholder="请输入公司邮箱" style="width: 256px;"></el-input>
            </el-form-item>
            <el-form-item label="企业LOGO：">
              <el-upload
                class="avatar-uploader"
                :action="`${uploadUrl}/api/fileStorage/uploadFile`"
                :data="{token}"
                :show-file-list="false"
                :on-success="handleLogoSuccess"
                :before-upload="beforeLogoUpload">
                <div v-if="imageUrl" class="avatar">
                  <i class="el-icon-remove" @click.stop="clearLogo"></i>
                  <img :src="imageUrl" class="w-full">
                </div>
                <div v-else class="avatar-uploader-icon">
                  <i class="el-icon-plus"></i>
                  <p>上传图片</p>
                </div>
              </el-upload>
              <div class="yellow-text">允许上传图片的格式为 jpg、jpeg、gif、bmp、png</div>
              <div class="yellow-text">建议尺寸大小：100 x 100 像素</div>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="submitForm" class="normal-button">提交</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </template>
  </BaseContainer>
</div>
</template>

<script>
import { getCity } from '@/api/fetch'
import GlobalConfig from '@/global/config'
import { AuthConfig } from '@/global/config'
import BaseContainer from '@/layout/base/BaseContainer'
import { toVersionPrice } from '@/assets/js/base-platform'
import { getCompanyData, setCompanyData, getCompanyMemberByCompanyIdApi, getCompanyInfo, getSysConfig } from '@/api/company/setting'
import { getDomain } from '@/assets/js/config/env'
export default {
  name: 'setting',
  components: { BaseContainer },
  data() {
    return {
      AuthConfig,
      uploadUrl: getDomain(),
      city: [],
      areaCity: [],
      form: {
        name: '',
        area: '',
        address: '',
        principal: '',
        telephone: '',
        email: '',
        logo: ''
      },
      rules: {
        name: [
          { required: true, message: '请输入公司名称', trigger: 'blur' },
          { min: 4, max: 120, message: '请输入4-120个字符', trigger: 'blur' }
        ],
        area: [
          { required: true, message: '请选择公司地址', trigger: 'change' }
        ],
        address: [
          { required: true, message: '请输入详细地址', trigger: 'blur' },
          { min: 4, max: 120, message: '请输入4-120个字符', trigger: 'blur' }
        ],
        principal: [
          { required: true, message: '请输入负责人', trigger: 'blur' }
        ],
        telephone: [
          { required: true, message: '请输入联系电话', trigger: 'blur' },
          { validator:(rule,value,callback) => {
              const reg = /^1(3|4|5|6|7|8|9)\d{9}$/
              if (!reg.test(value)) {
                callback(new Error('请输入正确的手机号'))
              } else {
                callback()
              }
            }, trigger: 'blur'
          },
        ],
        email: [
          { required: true, message: '请输入公司邮箱', trigger: 'blur' }
        ],
      },
      imageUrl: '',
      companyVersionData: {}
    }
  },
  computed: {
    token() {
      return GlobalConfig.getBaseToken()
    }
  },
  methods: {
    toVersionPrice,
    // 清除logo
    clearLogo() {
      this.imageUrl = ''
      this.form.logo = ''
    },
    // logo上传成功
    handleLogoSuccess(res, file) {
      this.form.logo = res
      this.imageUrl = URL.createObjectURL(file.raw)
    },
    // logo上传前的校验
    beforeLogoUpload(file) {
      const types = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'image/bmp']
      const isJPG = types.includes(file.type)
      if (!isJPG) {
        this.$message.error('允许上传图片的格式为 jpg、jpeg、gif、bmp、png')
      }
      return isJPG
    },
    // 城市选择事件
    chooseCity(val) {
      const city0 = this.city.filter(item => item.value === val[0])[0]
      const city1 = city0.children.filter(item => item.value === val[1])[0]
      const city2 = city1.children.filter(item => item.value === val[2])[0]
      this.form.area = [city0.label, city1.label, city2.label].join(' / ')
    },
    // 修改企业信息
    submitForm() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          setCompanyData(this.form).then(res => {
            this.$message.success('设置企业成功')
          }).catch((err) => {console.log(err)})
        } else {
          this.$message.error('请检查信息是否正确！')
          return false
        }
      })
    },
    // 获取企业信息
    getData() {
      getCompanyData().then(res => {
        this.form = res
        this.imageUrl = this.form.logo
        const cites = this.form.area.replace(/\s+/g, '').split('/')
        const city0 = this.city.filter(item => item.label === cites[0])[0]
        const city1 = city0.children.filter(item => item.label === cites[1])[0]
        const city2 = city1.children.filter(item => item.label === cites[2])[0]
        this.areaCity = [city0.value, city1.value, city2.value]
      }).catch((err) => {console.log(err)})
    },
    // 获取尊享版本信息
    getCompanyVersionData() {
      const [ type, expirationTime ] = [ GlobalConfig.getAuthCode(), GlobalConfig.getExpirationTime()]
      this.companyVersionData = {type, expirationTime}
    }
  },
  async created() {
    await getCity().then(res => {
      this.city = res
    })
    this.getData()
    this.getCompanyVersionData()
  }
}
</script>

<style scoped lang="scss">
.admin-list-wrap{
  height: 100%;
  background: #FFFFFF;
  box-shadow: 0 1px 4px 0 #0000000f;
  border-radius: 2px;
  display: flex;
  flex-direction: column;
  .banner {
    width: 100%;
    height: 100px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    border-radius: 2px;
    div {
      display: flex;
      justify-content: center;
    }
  }
  .basic-banner {
    color: #e8a31b;
    background-image: linear-gradient(270deg,#ffd970,#fff3c2 100%,#fff3c2 0);
    .mini-btn {
      padding: 0 8px;
      margin-left: 12px;
    }
  }
  .common-banner {
    align-items: center;
    font-size: 18px;
    color: #6C748A;
    line-height: 22px;
    background-image: linear-gradient(270deg,#C4C7CF,#D9DBDF 100%,#EDEDF0 0);
  }
  .form-box {
    width: 100%;
    overflow: auto;
    display: flex;
    justify-content: center;
    box-sizing: border-box;
    padding-top: 40px;
    padding-bottom: 20px;
  }
  .form {
    height: 100%;
    width: 435px;
    .avatar-uploader {
      width: 104px;
      height: 104px;
      background: #F2F5FA;
      border-radius: 2px;
      margin-bottom: 2px;
      .avatar {
        width: 104px;
        position: relative;
        i {
          position: absolute;
          right: -7px;
          top: -7px;
          color: #E34152;
        }
      }
      .avatar-uploader-icon {
        width: 104px;
        text-align: center;
        font-size: 14px;
        padding-top: 20%;
        color: rgba(0, 0, 0, 0.65);
        i {
          font-size: 24px;
        }
      }
    }
    .yellow-text {
      color: #E8A31B;
      font-size: 12px;
      line-height: 16px;
    }
  }
}
</style>
